import styled from "styled-components";

export const BodyLoading = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: #ffffff;
  z-index: 99;
  padding: 0 16px;
`;

export const BodyLoadingSpin = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  animation: delay-show 2000ms forwards;
  img {
    width: 37px;
    animation: rotate-animation 1s infinite linear;
  }
  @keyframes delay-show {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes rotate-animation {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
